import { useEffect } from 'react';
import { siteConfig } from '../config/site';

type SeoProps = {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
  noIndex?: boolean;
};

function setMeta(selector: string, attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = content;
}

export function Seo({ title, description, path = '/', image = '/og-image.png', noIndex = false }: SeoProps) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${siteConfig.brand.name}` : `${siteConfig.brand.name} — ${siteConfig.brand.tagline}`;
    const summary = description ?? siteConfig.brand.description;
    const canonicalUrl = new URL(path, siteConfig.domain).toString();
    const imageUrl = new URL(image, siteConfig.domain).toString();

    document.title = fullTitle;
    setMeta('meta[name="description"]', 'name', 'description', summary);
    setMeta('meta[property="og:title"]', 'property', 'og:title', fullTitle);
    setMeta('meta[property="og:description"]', 'property', 'og:description', summary);
    setMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);
    setMeta('meta[property="og:image"]', 'property', 'og:image', imageUrl);
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', fullTitle);
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', summary);
    setMeta('meta[name="robots"]', 'name', 'robots', noIndex ? 'noindex,nofollow' : 'index,follow');

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
  }, [description, image, noIndex, path, title]);

  return null;
}
